const defaultHoldForm = {
  type: 'sloper',
  z: 0,

  xRotation: 0,
  yRotation: 0,
  zRotation: 0,

  oneAxisScale: 0,
  xScale: 1,
  yScale: 1,
  zScale: 1
}

export { defaultHoldForm }
